const translations = {
  "en": {
    "Potential financial fitness score": "Potential financial fitness score",
    "What this plan does for your score": "What this plan does for your score"
  },
  "zh-tw": {
    "Potential financial fitness score": "潛在財務健康分數",
    "What this plan does for your score": "此計畫如何影響你的評分"
  }
};

export default translations;
